// import * as types from '../mutation-types'
// import prService from '../api/services/pr'

import prService from "../api/services/prService"


const state = { // คล้าย data
  name: '',
  history: { data: [] },
  currentStaus: { data: [] },
  unit: { data: [] },
  itemSpac: { data: [] },
  config: { data: [] }
}
// call state
// this.#store.state.[filename].name
// this.#store.state.prDoc.name


const mutations = { // คล้าย property
  setName(state, payload) {
    state.name = payload.name
  },
  setPrHistory(state, payload) {
    // console.log('before',state.history)
    state.history = payload
    // console.log('after',state.history)
  },
  setPrCurrentStaus(state, payload) {
    state.currentStaus = payload
  },
  setPrUnit(state, payload) {
    state.unit = payload
  },
  setPrItemSpec(state, payload) {
    state.itemSpac = payload
  },
  setConfig(state, payload) {
    state.config = payload
  },
  saveConfig(state) {
    prService.prconfigUpdate(state.config[0])
  },

}
// call mutations
// this.$store.commit('[mutationName]',{name:'pom'})
// this.$store.commit('setName',{name:'pom'})

const actions = { // ก็เหมือน Methods แต่จะต่างตรงที่ จะเรียก mutations แบบ async
  actionName({ commit }, playload) {
    commit('setName', playload)
  },
  async prloadHistory({ commit, rootState }) {
    let payload = {}
    if (localStorage.getItem('prItemHistory')) {
      payload = JSON.parse(localStorage.getItem('prItemHistory'))
      commit('setPrHistory', payload)
      return
    }
    payload = await prService.prItemHistory({
      pageNo: 1,
      rowsPerPage: 5000,
      sortBy: 'item',
      descending: '',
      search: '',
      PRCode: rootState.users.empMy[0].PRCode
    })
    console.log('pritemHistory', payload.data)
    if (!payload.data.data) {
      payload.data.data = [{ "Item": "", "Qty": 1, "price": 0, "unit": "", "itemSpac": "", "remText": "", "PRCode": "", "itemText": "" }]
      console.log('pritemHistory', payload.data)
    }
    commit('setPrHistory', payload.data)
    localStorage.setItem('prItemHistory', JSON.stringify(payload.data))

  },
  async prCurrentStatus({ commit }) {
    if (localStorage.getItem('prHistoryStaus')) {
      payload = JSON.parse(localStorage.getItem('prHistoryStaus'))
      commit('setPrCurrentStaus', payload)
      return
    }
    let payload = await prService.prHistory({
      pageNo: 1,
      rowsPerPage: 5000,
      sortBy: '',
      descending: '',
      search: '',
      history: 'currentStatus'

    })
    commit('setPrCurrentStaus', payload.data)
    localStorage.setItem('prHistoryStaus', JSON.stringify(payload.data))
  },
  async prUnit({ commit }) {
    if (localStorage.getItem('prUnit')) {
      payload = JSON.parse(localStorage.getItem('prUnit'))
      commit('setPrUnit', payload)
      return
    }
    let payload = await prService.prHistory({
      pageNo: 1,
      rowsPerPage: 5000,
      sortBy: '',
      descending: '',
      search: '',
      history: 'unit'
    })
    commit('setPrUnit', payload.data)
    localStorage.setItem('prUnit', JSON.stringify(payload.data))
  },
  async prItemSpec({ commit }) {
    let payload = {}
    if (localStorage.getItem('prItemSpec')) {
      payload = JSON.parse(localStorage.getItem('prItemSpec'))
      commit('setPrItemSpec', payload)
      return
    }
    payload = await prService.prHistory({
      pageNo: 1,
      rowsPerPage: 5000,
      sortBy: '',
      descending: '',
      search: '',
      history: 'itemSpac'
    })
    commit('setPrItemSpec', payload.data)
    localStorage.setItem('prItemSpec', JSON.stringify(payload.data))
  },
  async prConfig({ commit, rootState }) {
    let payload = await prService.prconfigListByParam({
      empCode: rootState.users.empMy[0].EmpCode
    })
    if (payload.data.data.length !== 0) {
      commit('setConfig', payload.data.data)
    } else {
      commit('setConfig', [{
        "empCode": rootState.users.empMy[0].EmpCode,
        "appv1": null,
        "appv2_1": null,
        "appv2_2": null,
        "appv2_3": null,
        "appv2_4": null,
        "appv2_5": null
      }])
    }
  },
}
// call actions
// this.$store.dispatch('[actionName]')
// this.$store.dispatch('actionName')


const getters = { // คล้าย Compute
  nameLen(state) {
    return state.name.length
  },
  // prHistory(state) {
  //   return state.history.data.map((his) => {
  //     return his.item
  //   })
  // },
  prItemHistory(state) {
    return state.history.data.map(obj => {
      const hasValue = val => val != null ? val : ''
      obj.itemText = hasValue(obj.Item) + hasValue(obj.Qty.toString()) + hasValue(obj.price.toString()) + hasValue(obj.unit) + hasValue(obj.itemSpac)
      return obj
    })
  },
  prCurrentStatusHistory(state) {
    return state.currentStaus.data
  },
  prUnitHistory(state) {
    return state.unit.data
  },
  prItemSpecHistory(state) {
    return state.itemSpac.data
  },
  prConfig(state) {
    if (state.config.length > 0) {
      return state.config[0]
    } else {
      return {}
    }
  },
}
//call getters  this.$store.getters.[getterName]
// this.$store.getters.nameLen


export default {
  state,
  mutations,
  getters,
  actions
}